import { useLDClient } from 'launchdarkly-react-client-sdk'

export const useFeatureFlagClient = useLDClient
